import {
  ResolutionFilters,
  ResolutionsHeader,
  ResolutionsTable
} from '@bo-components/resolutions/resolutionsList';
import {
  ResolutionsListFiltersContext,
  useResolutionsList
} from '@bo-hooks/resolutions/resolutionsList';
import { PageBody } from '@library/components/layout/PageBody';
import { selectHasCreateResolution } from '@bo-selectors/resolutions/resolutionPermisions';
import { useSelector } from 'react-redux';

export const ResolutionsList = () => {
  const hasCreateResolution = useSelector(selectHasCreateResolution);
  const { resolutionsListFiltersContext } = useResolutionsList();

  return (
    <>
      <ResolutionsHeader
        disableCreateResolution={!hasCreateResolution}
        isHomePage
        title="All Resolutions"
      />
      <PageBody>
        <ResolutionsListFiltersContext.Provider
          value={resolutionsListFiltersContext}
        >
          <ResolutionFilters />
          <ResolutionsTable />
        </ResolutionsListFiltersContext.Provider>
      </PageBody>
    </>
  );
};
